import React, { useEffect, useState } from "react";
import AddLocation from "./AddLocation";
import { getAdminUserList } from "../../services/super-admin.service";
import AddIcon from "../../assets/images/add_icon.svg";
import toast from "react-hot-toast";
import PaginatedTable from "../common/PaginatedTable";
import { getLocation } from "../../services/Location.service"
const LocationList = () => {


  const [list, setList] = useState([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showTable, setShowTable] = useState(true);

  //Paginated Table Variables
  let [totalCount, setTotalCount] = useState(0);
  let [currentPage, setCurrentPage] = useState(1);
  let [itemsPerPage, setItemsPerPage] = useState(10);
  let [searchKey, setSearchKey] = useState("");
  let [isLoading, setIsLoading] = useState(true);
  const [maxPageNumberLimit, setMaxPageNumberLimit] = useState(5);
  const [minPageNumberLimit, setMinPageNumberLimit] = useState(0);

  const handleShowCreate = () => {
    setShowCreate(true);
    setShowTable(false);
  };

  const back = (cond = true) => {
    cond && getLocationList();
    setShowCreate(false);
    setShowTable(true);
  };

  useEffect(() => {
    getLocationList();
  }, [currentPage, itemsPerPage, searchKey, setSearchKey]);

  const [column, setColumn] = useState([
    // {
    //   heading: () => "S.No",
    //   cell: (row, i) => {
    //     return i;
    //   },
    //   hidden: false,
    //   width: "20",
    //   id: 1,
    // },
    {
      heading: () => "Location Name",
      cell: (row) => (row["name"] ? row["name"] : "-"),
      hidden: false,
      width: "120",
      align: "left",
      id: 1,
    },
    {
      heading: () => "Type",
      cell: (row) => (row["type"] ? row["type"] : "-"),
      hidden: false,
      width: "120",
      align: "left",
      id: 2,
    },

    {
      heading: () => "Action",
      cell: (row) => (
        <span className={row?.active_flag ? "fontWeight600 UFOGreen_text" : "fontWeight600 errorClr_text"}>
          {row["active"] ? "Active" : "Inactive"}
        </span>
      ),
      hidden: false,
      width: "120",
      align: "left",
      id: 3,
    },
  ]);

  // const adminUserList = async () => {
  //   const offset = (currentPage - 1) * itemsPerPage;
  //   const offsetToUse = offset >= 0 ? offset : 0;

  //   try {
  //     const requestBody = {
  //       offset: offsetToUse,
  //       limit: itemsPerPage,
  //       search: searchKey,
  //     };
  //     let res = await getAdminUserList(requestBody);
  //     if (res?.status === 200 && res?.data?.statusCode === 200) {
  //       setList(res?.data?.data);
  //       setTotalCount(res?.data?.count);
  //     } else {
  //       toast.error(res?.message || res?.data?.message);
  //     }
  //   } catch (error) {
  //     if (error?.message) {
  //       const msg = error?.message?.split(":")?.[1]?.trim();
  //       console.error(msg);
  //       // alert(msg);
  //     }
  //     console.log(error.message);
  //   }
  // };

  const getLocationList = async () => {
    try {
      const res = await getLocation();


      if (res?.status === 200) {

        if (res?.data) {
          setList(res?.data);
        }
      } else {
        toast.error(res?.message || res?.data?.message);
      }
    } catch (error) {
      if (error?.message) {
        const msg = error?.message?.split(":")?.[1]?.trim();
        // alert(msg);
        console.error(msg);
      }
      console.log(error.message);
    }
  };

  return (
    <div>
      {showTable && (
        <div>
          <div className="mb_24 displayFlex alignItem_center justifyContent_spacebetween">
            <div>
              <h5 className="fontSize20 fontWeight600 blackClr_text">
                {" "}
                Location List
              </h5>
            </div>
            <div>
              <button
                className="MainButton cyanSky_clr gap8"
                type="button"
                onClick={handleShowCreate}
              >
                <img className="width20px" src={AddIcon} alt="AddIcon" />
                <span> Add Location </span>
              </button>
            </div>
          </div>

          {isLoading ? (
            <PaginatedTable
              row={list}
              column={column}
              totalCount={totalCount}
              itemsPerPage={itemsPerPage}
              setItemsPerPage={setItemsPerPage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              isSearch={true}
              searchKey={searchKey}
              setSearchKey={setSearchKey}
              maxPageNumberLimit={maxPageNumberLimit}
              setMaxPageNumberLimit={setMaxPageNumberLimit}
              minPageNumberLimit={minPageNumberLimit}
              setMinPageNumberLimit={setMinPageNumberLimit}
              //   setRange={setRange}
              //   range={range}
              isExport={false}
              isDateRange={false}
            //   handleExport={() => handleExportTransactions()}
            />
          ) : (
            <div style={{ textAlign: "center" }}>Loading...</div>
          )}
        </div>
      )}

      {showCreate && <AddLocation back={back} />}
    </div>
  );
};

export default LocationList;
